import { CustomFieldDefinition } from '__types__';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getCustomFieldDefinitions } from 'store/v1/custom_fields/custom_fields.selectors';

/**
 * Non-archived custom field display names from Redux (duplicate checks in the config form).
 * Mount under react-redux `Provider` (app already does; Storybook stories use a decorator).
 */
export function useExistingCustomFieldNames(): readonly string[] {
  const definitions = useSelector(getCustomFieldDefinitions);
  return useMemo(
    () =>
      definitions
        ?.filter((f: CustomFieldDefinition) => !f.archived)
        .map(f => f.name) ?? [],
    [definitions]
  );
}
